import { JOIN_TYPE } from '@/common/constants/ConstCode';
import { cloneDeep } from 'lodash';
const { GENERAL } = JOIN_TYPE;
export default {
  setAccessToken(state, accessToken = null) {
    state.accessToken = accessToken;
  },
  setRefreshToken: (state, refreshToken = null) => {
    state.refreshToken = refreshToken;
  },
  setIsPremium: (state, isPremium = false) => {
    state.signUp.isPremium = isPremium;
  },
  setCouponNumber: (state, couponNumber = null) => {
    state.signUp.couponNumber = couponNumber;
  },
  setPurchase: (state, purchase) => {
    state.purchase = purchase;
  },
  setUserPremiumUpdate: (state, isPremium = false) => {
    state.userData.isPremium = isPremium;
  },
  setUserBenefitInfo: (state, responseInfo) => {
    state.userData = { ...state.userData, ...responseInfo };
  },
  setUserPoint: (state, point) => {
    state.userData.point = point;
  },
  setJoinType: (state, joinType = GENERAL.value) => {
    console.log('setJoinType', joinType);
    state.signUp.form.joinType = joinType;
  },
  setUserData(
    state,
    userData = {
      authNo: null,
      userId: null,
      joinType: GENERAL.value,
      role: null,
      status: null,
      userNo: null,
      name: null,
      phone: null,
      familyCode: '', // 가족 관련 접근에 필요한 family Code,
      familyName: '', // 가족의 명칭,
      isRepresent: false, // 대표를 맡고 있는 가족이 있는지 여부 체크용도 ( 모든 가족 통틀어서 )
      currentRepresent: false, // 현재 접속한 가족정보에서 내가 대표인지 체크,
      userGrade: '',
      passExpireDate: '',
      benefitExpireDate: '',
      point: 0
    }
  ) {
    state.userData = userData;
  },
  setDeviceInfo(
    state,
    deviceInfo = {
      deviceNo: null,
      userNo: null,
      deviceType: 'WEB',
      deviceId: 'WEB',
      pushToken: null,
      appVersion: '1.0.0',
      os: 'WEB'
    }
  ) {
    state.deviceInfo = deviceInfo;
  },

  setAuthCode(state, authCode) {
    state.authCode = authCode.toString() || '';
  },
  setPhone(state, { phone, code }) {
    state.code = code;
    state.phone = phone;
  },
  setFindData(state, findData) {
    state.find.form = { ...findData };
  },
  storeLogin(state, { userData = {}, accessToken, refreshToken }) {
    state.accessToken = accessToken;
    state.refreshToken = refreshToken;
    state.userData = userData;
    state.ttl = new Date().getTime();
    state.role = userData?.role;
  },
  storeLogout(state) {
    state.accessToken = '';
    state.refreshToken = '';
    state.ttl = '';
    Object.keys(state.userData).forEach(key => (state.userData[key] = ''));
    state.role = '';
    state.userData.isRepresent = false;
    state.userData.currentRepresent = false;
    state.userData.isNotFamily = false;
  },
  setSignUp(state, payload) {
    state.signUp.form = cloneDeep(payload);
  },
  setDuplicated(state, duplicated) {
    state.signUp.duplicated = duplicated;
  },
  setIsSns(state, flag = false) {
    state.signUp.isSns = flag;
  },
  setSignUpReset(state) {
    state.authCode = '';
    state.familyList = [];
    // state.signUp.form = {
    //   isAgreeMarketing: false,
    //   joinType: GENERAL.value

    // };

    state.signUp.form = Object.fromEntries(Object.entries(state.signUp.form).map(([key, value]) => [key, '']));
    state.signUp.phoneCode = '';
    state.signUp.isPremium = false;
    state.signUp.codeNumber = null;
    state.signUp.phoneState = '';
    state.signUp.isAgreeService = false;
    state.signUp.isAgreePrivacy = false;
    state.signUp.duplicated = false;
  },

  setSignUpUserType(state, payload) {
    state.signUp.form.churchNo = payload.churchNo ?? '';
    state.signUp.form.familyCode = payload.familyCode ?? '';
    state.signUp.form.familyName = payload.familyName ?? '';
    state.signUp.form.userNo = payload.userNo ?? '';
    state.signUp.form.joinMenu = payload.joinMenu ?? '';
  },
  setFamilyList(state, list) {
    state.familyList = list ?? [];
  },
  setPurchaseCallBack(state, callBack) {
    state.purchaseCallBack = callBack;
  },
  ttlInit(state) {
    state.ttl = new Date().getTime();
  },
  setTerms(state, terms) {
    state.terms = terms;
  },
  setFirstLogin(state, flag) {
    state.firstLoginChk = flag;
  },
  setFindPhone(state, phone) {
    state.find.form.phone = phone;
  },

  updateReadState(state, isRead) {
    state.userData.isRead = isRead;
  },

  setFindUserId(state, userId) {
    state.find.form.userId = userId;
  },

  setFamilyCode(state, familyCode) {
    state.userData.familyCode = familyCode;
  },
  initCurrentFamily(state) {
    state.userData.familyName = '';
    state.userData.currentRepresent = false;
    state.userData.familyCode = '';
  },
  setFamilyName(state, familyName) {
    state.userData.familyName = familyName;
  },
  setIsNotFamily(state, isFamily) {
    state.userData.isNotFamily = isFamily;
  },
  setIsRepresent(state, isRepresent) {
    state.userData.isRepresent = isRepresent;
  },
  setRepresentFamilyCode(state, familyCode) {
    state.userData.representFamilyCode = familyCode;
  },
  setRepresentFamilyName(state, familyName) {
    state.userData.representFamilyName = familyName;
  },
  setCurrentRepresent(state, currentRepresent) {
    state.userData.currentRepresent = currentRepresent;
  },
  setAgreeMarketing(state, isAgreeMarketing) {
    state.userData.isAgreeMarketing = isAgreeMarketing;
  },
  setAgreeBusinessMarketingPush(state, isAgreeBusinessMarketingPush) {
    state.userData.isAgreeBusinessMarketingPush = isAgreeBusinessMarketingPush;
  },

  setSignUpChurchInfo(state, payload) {
    state.signUp.form = { ...state.signUp.form, ...payload };
  },

  setChurchInfo(state, churchInfo) {
    state.userData.churchNo = churchInfo.churchNo;
    state.userData.churchName = churchInfo.churchName;
  },

  // 260628: 웰다잉 비번 설정 여부(bcrypt). login 응답·설정 직후 반영 → 마이노트 진입 분기에 사용. (구 setWellPassword=평문PIN 잔재 제거)
  setHasWellPassword(state, has) {
    state.userData.hasWellPassword = has;
  },

  setFindAccounts(state, findAccounts = []) {
    state.findAccounts = findAccounts;
  }
};
